import { Typography, Box, Grid } from "@mui/material";

interface InstructionItemProps {
    number: number;
    children?: React.ReactNode;
    numberSize?: number;
}

const InstructionItem: React.FC<InstructionItemProps> = ({ number, children, numberSize = 50 }) => {
    return (
        <Grid container alignItems="flex-start" spacing={2} wrap="nowrap">
            <Grid item>
                <Box
                    bgcolor="primary.main"
                    color="primary.contrastText"
                    borderRadius="50%"
                    width={numberSize}
                    height={numberSize}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography variant="h5">{number}</Typography>
                </Box>
            </Grid>
            <Grid item xs>
                {children}
            </Grid>
        </Grid>
    );
};

export default InstructionItem;
